angular.module('app.api').factory('CandidatePreferencesApi', [
  'api',
  function CandidatePreferencesApi(api) {
    const candidatePreferencesApi = {
      updateCandidatePreferences: async (id, preferences) => {
        const payload = {
          candidatePreference: preferences,
        }
        return api.put(`users/${id}/profile`, payload)
      },
    }
    return candidatePreferencesApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/lawyer-preferences/candidate-preferences.api.js